import { Plus } from '@styled-icons/bootstrap'
import PortfolioModal from './PortfolioModal'
import { useState } from 'react'

function PortfolioItem(props) {
	const [isOpen, setOpen] = useState(false)

	return (
		<div>
			<PortfolioModal
				clickOutside={state => setOpen(state)}
				isOpen={isOpen}
				title={props.title}
				image={props.image}
			/>
			<div className='w-full h-[300px] relative'>
				<img
					src={props.image}
					alt='portfolio'
					className='w-full h-full object-cover z-0'
				/>
				<div
					onClick={() => setOpen(!isOpen)}
					className='w-full h-full z-10 bg-yellow-100 opacity-0 hover:opacity-70 top-0 flex absolute items-center justify-center transition duration-200 cursor-pointer'
				>
					<Plus className='w-[54px] h-[54px] fill-white' />
				</div>
			</div>
		</div>
	)
}

export default PortfolioItem
